import { Box, Dialog } from '@material-ui/core'
import React, { FC, useState } from 'react'
import { FullScreenStepperActions } from '../FullScreenStepperActions'
import { FullScreenStepperHeader } from '../FullScreenStepperHeader'
import { FullScreenStepperContext } from './FullScreenStepperContext'
import { FullScreenStepperProps } from './FullScreenStepperProps'

/**
 * TODO
 * - i18n?
 * - loading?
 */

export const FullScreenStepper: FC<FullScreenStepperProps> = (props) => {
  const {
    children,
    context = {},
    defaultStepCursor = 1,
    displayActionBar = true,
    displayCancelButton = true,
    displayPreviousButton = true,
    resetStepCursorOnCancel = true,
    resetStepCursorOnClose = true,
    steps,
    onClose,
    onFinish,
    onNext,
    onCancel,
    onPrevious,
    ...DialogProps
  } = props
  const [stepCursor, setStepCursor] = useState(defaultStepCursor)
  const stepCount = steps.length
  const stepIndex = stepCursor - 1
  const step = steps[stepIndex]
  const { displayActionBar: displayStepActionBar = true } = step
  const isFinalStep = stepCursor / stepCount === 1
  const callbackArgs = { setStepCursor, step, stepCount, stepIndex, steps }
  const mergedContext = { ...context, ...callbackArgs }
  const resetStepCursor = () => setTimeout(() => setStepCursor(1), 600)
  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose(callbackArgs)
    }
    if (resetStepCursorOnClose) {
      resetStepCursor()
    }
  }
  const handleNextClick = async () => {
    if (isFinalStep) {
      if (typeof onFinish === 'function') {
        await onFinish(callbackArgs)
      }
      if (typeof onClose === 'function') {
        onClose(callbackArgs)
      }
      resetStepCursor()
    } else {
      if (typeof onNext === 'function') {
        await onNext(callbackArgs)
      }
      setStepCursor(stepCursor + 1)
    }
  }
  const handlePreviousClick = async () => {
    if (typeof onPrevious === 'function') {
      await onPrevious(callbackArgs)
    }
    setStepCursor(stepCursor - 1)
  }
  const handleCancelClick = async () => {
    if (typeof onCancel === 'function') {
      await onCancel(callbackArgs)
    }
    if (resetStepCursorOnCancel) {
      resetStepCursor()
    }
  }
  const content = React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.props.name === step.name,
  )

  return (
    <Dialog fullScreen {...DialogProps}>
      <FullScreenStepperContext.Provider value={mergedContext}>
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <FullScreenStepperHeader stepCount={stepCount} stepCursor={stepCursor} onClose={handleClose} step={step} />
          <Box display="flex" mx={6} flexGrow={1} alignItems="center" flexDirection="column">
            {content}
          </Box>
          {displayActionBar && displayStepActionBar && (
            <FullScreenStepperActions
              {...step.actionBar}
              callbackArgs={callbackArgs}
              displayCancelButton={displayCancelButton}
              displayPreviousButton={displayPreviousButton}
              stepCount={stepCount}
              stepCursor={stepCursor}
              setStepCursor={setStepCursor}
              handleCancelClick={handleCancelClick}
              handleNextClick={handleNextClick}
              handlePreviousClick={handlePreviousClick}
            />
          )}
        </Box>
      </FullScreenStepperContext.Provider>
    </Dialog>
  )
}

FullScreenStepper.displayName = 'FullScreenStepper'
